module.exports = __webpack_public_path__ + "static/media/right trouser.b3aeef00.png";